import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import cross from "../public/images/ui-icons_222222_256x240.png";

export class CloseButton extends PureComponent {
    render() {
        return (
            <Container role="button" unselectable="on" onClick={this.props.action}>
                <Cross unselectable="on">close</Cross>
            </Container>
        );
    }
}

const Container = styled.span`
    cursor: pointer;
`;

const Cross = styled.span`
    display: block;
    text-indent: -99999px;
    overflow: hidden;
    background-repeat: no-repeat;
    width: 16px;
    height: 16px;
    background-image: url(${cross});
    background-position: -96px -128px;
`;

CloseButton.propTypes = {
    action: PropTypes.func
};
